<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-title>
              <div>
                <v-tabs v-model="tab">
                  <v-tab v-for="(category, itemKey) in assetCategories" :key="itemKey" @click="getAssets(category.Asset_Category_ID)">
                    <span>{{ category.Category_Name }}</span>
                  </v-tab>
                </v-tabs>
              </div>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-row class="mb-1">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search asset"
                  single-line
                  class="shrink ml-5"
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-btn
                  small
                  color="primary"
                  class="mt-2 mr-3"
                  outlined
                  @click.prevent="exportToXLSX"
                >
                  Export To XLSX
                </v-btn>
                <v-btn
                  small
                  color="success"
                  class="mt-2 mr-3"
                  @click.prevent="addNewAsset"
                >
                  Add Asset
                </v-btn>
              </v-row>
              <v-tabs-items v-model="tab">
                <v-tab-item v-for="(category, itemKey) in assetCategories" :key="itemKey">
                  <div
                    class="pb-4 d-flex flex-wrap"
                    v-if="currentSubcategories.length > 1"
                  >
                    <v-switch
                      class="mx-3"
                      v-for="(subcategory, subKey) in currentSubcategories"
                      :key="subKey"
                      dense
                      :label="subcategory.Subcategory_Name"
                      v-model="subcategory.Show"
                      hide-details
                    ></v-switch>
                  </div>
                  <v-divider></v-divider>
                  <v-data-table
                    mobile-breakpoint="0"
                    fixed-header
                    :height="tableHeight"
                    :headers="assets_headers"
                    :items="filteredAssets"
                    :items-per-page="50"
                    :footer-props="{
                      'items-per-page-options': [30, 50, 100, -1]
                    }"
                    :search="search"
                    @click:row="onAssetRowClick"
                  >
                    <template v-slot:[`item.Warranty_End_Date`]="{ item }">
                      {{ item.Warranty_End_Date | dateFilter }}
                    </template>
                    <template v-slot:[`item.Full_Name`]="{ item }">
                      <span
                        @click.stop="openEmployeeCard(item.Employee_ID)"
                        style="cursor: pointer; text-decoration: underline;"
                      >
                        {{ item.Full_Name }}
                      </span>
                    </template>
                    <template v-slot:[`item.Lease_Agreement`]="{ item }">
                      <v-icon v-if="item.Employee_ID && item.Lease_Agreement && (item.Category_Name === 'Computers' || item.Category_Name === 'Monitors')" class="border-black" color="primary">mdi-check</v-icon>
                      <v-icon v-else-if="item.Employee_ID && !item.Lease_Agreement && (item.Category_Name === 'Computers' || item.Category_Name === 'Monitors')" class="border-black" color="red">mdi-close</v-icon>
                    </template>
                  </v-data-table>
                </v-tab-item>
              </v-tabs-items>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <AssetDetails
      v-model="show"
      :addMode="addMode"
      :asset="selecetedAsset"
      :assetCategories="assetCategories"
      :assetSubcategories="assetSubcategories"
    />
  </div>
</template>

<script>
import { getApiErrorMessage } from '@/utils/apiError'
import { formatLocalDate } from '@/utils/dateUtils'

const xlsx = require('json-as-xlsx')

export default {
  name: 'Assets',
  components: {
    AssetDetails: () => import('@/components/assets/AssetDetails.vue')
  },
  data () {
    return {
      assets: [],
      search: '',
      selecetedAsset: {},
      addMode: false,
      showAsset: false,
      assetCategories: [],
      assetSubcategories: [],
      currentAssetCategory: null,
      tab: 0,
      assets_headers: [
        {
          text: 'Category',
          value: 'Category_Name',
          divider: true,
          class: 'px-2 text-no-wrap'
        },
        {
          text: 'Subcategory',
          value: 'Subcategory_Name',
          divider: true,
          class: 'px-2 text-no-wrap'
        },
        {
          text: 'Inventory #',
          value: 'Invertory_Number',
          divider: true,
          class: 'px-2 text-no-wrap'
        },
        {
          text: 'Brand',
          value: 'Brand',
          divider: true,
          class: 'px-2 text-no-wrap'
        },
        {
          text: 'Model',
          value: 'Model',
          divider: true,
          class: 'px-2 text-no-wrap'
        },
        {
          text: 'Warranty End Date',
          value: 'Warranty_End_Date',
          divider: true,
          class: 'px-2 text-no-wrap'
        },
        {
          text: 'Employee',
          value: 'Full_Name',
          divider: true,
          class: 'px-2 text-no-wrap'
        },
        {
          text: 'Status',
          value: 'Status',
          divider: true,
          class: 'px-2 text-no-wrap'
        },
        {
          text: 'Lease Agreement',
          value: 'Lease_Agreement',
          divider: true,
          width: '5%',
          class: 'px-2 text-no-wrap'
        }
      ]
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    tableHeight () {
      const windowW = window.innerWidth
      if (this.tab === 0) {
        return windowW < 768 ? '' : 'calc(100vh - 320px)'
      } else {
        return windowW < 768 ? '' : 'calc(100vh - 380px)'
      }
    },
    show: {
      get () {
        return this.showAsset
      },
      set (val) {
        if (!val) {
          this.getAssets(this.assetCategories[this.tab].Asset_Category_ID)
        }
        this.showAsset = val
      }
    },
    currentSubcategories () {
      return this.assetSubcategories.filter(item => item.Asset_Category_ID === this.assetCategories[this.tab].Asset_Category_ID)
    },
    shownSubcategoriesIDs () {
      const res = []
      for (let i = 0; i < this.currentSubcategories.length; i++) {
        if (this.currentSubcategories[i].Show) res.push(this.currentSubcategories[i].Asset_Subcategory_ID)
      }
      return res
    },
    filteredAssets () {
      if (this.tab === 0) {
        return this.assets
      } else {
        return this.assets.filter(item => this.shownSubcategoriesIDs.indexOf(item.Asset_Subcategory_ID) > -1)
      }
    }
  },
  mounted () {
    this.getAssetCategories()
  },
  methods: {
    getAssets (categoryId) {
      if (categoryId === 0) {
        this.getAllAssets()
      } else {
        this.axios.get(`/api/assets/${categoryId}`, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(res => {
          this.assets = res.data
        }).catch(error => {
          const errorMsg = getApiErrorMessage(error)
          this.$store.dispatch('setError', { errorMsg })
        })
      }
    },
    getAllAssets () {
      this.axios.get('/api/assets', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.assets = res.data
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    getAssetCategories () {
      this.axios.get('/api/asset_categories', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.assetCategories.push({ Asset_Category_ID: 0, Category_Name: 'All' })
        for (let i = 0; i < res.data[0].length; i++) {
          this.assetCategories.push(res.data[0][i])
        }
        for (let i = 0; i < res.data[1].length; i++) {
          this.assetSubcategories.push({
            ...res.data[1][i],
            Show: true
          })
        }
        this.getAssets(this.assetCategories[0].Asset_Category_ID)
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    onAssetRowClick (item) {
      this.axios.get(`/api/assetdetails/${item.Asset_ID}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.selecetedAsset = res.data[0]
        this.addMode = false
        this.show = true
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    addNewAsset () {
      const newAsset = {
        Asset_ID: null,
        Asset_Category_ID: null,
        Category_Name: '',
        Asset_Subcategory_ID: null,
        Subcategory_Name: '',
        Employee_ID: null,
        Full_Name: null,
        Status_ID: null,
        Status: '',
        Invertory_Number: null,
        Brand: null,
        Model: null,
        Serial_Number: null,
        Type_OS: null,
        CPU: null,
        GPU: null,
        HDD_or_SSD: null,
        RAM: null,
        Motherboard: null,
        Video: null,
        Old_Name: null,
        Date_of_Creation: null,
        Description: null,
        Notes: null,
        Current_Status_Date: null,
        Lease_Agreement_Date: null,
        Seller_Name: '',
        Seller_Contacts: '',
        Receipt: null,
        Receipt_File_Name: '',
        Receipt_File_Type: '',
        Warranty_Document: null,
        Warranty_Document_Name: '',
        Warranty_Document_Type: '',
        Warranty_End_Date: null,
        Lease_Agreement_Document: null,
        Lease_Agreement_Document_Name: '',
        Lease_Agreement_Document_Type: ''
      }
      this.selecetedAsset = newAsset
      this.addMode = true
      this.show = true
    },
    openEmployeeCard (employeeID) {
      this.axios.get(`/api/employee/${employeeID}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.$store.dispatch('employeeDetailsScreen', {
          show: true,
          employee: res.data[0],
          edit: false
        })
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    exportToXLSX () {
      this.axios.get('/api/get_assets_data_for_xlsx', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        const data = [
          {
            sheet: 'Assets',
            columns: [
              {
                label: 'Category',
                value: 'Category_Name'
              },
              {
                label: 'Subcategory',
                value: 'Subcategory_Name'
              },
              {
                label: 'Employee',
                value: 'Full_Name'
              },
              {
                label: 'Status',
                value: 'Status'
              },
              {
                label: 'Inventory №',
                value: 'Invertory_Number'
              },
              {
                label: 'Brand',
                value: 'Brand'
              },
              {
                label: 'Model',
                value: 'Model'
              },
              {
                label: 'Serial №',
                value: 'Serial_Number'
              },
              {
                label: 'Date of Creation',
                value: row => row.Date_of_Creation ? formatLocalDate(row.Date_of_Creation) : ''
              },
              {
                label: 'Current Status Date',
                value: row => row.Current_Status_Date ? formatLocalDate(row.Current_Status_Date) : ''
              },
              {
                label: 'Lease Agreement Date',
                value: row => row.Lease_Agreement_Date ? formatLocalDate(row.Lease_Agreement_Date) : ''
              },
              {
                label: 'Description',
                value: row => {
                  let res = ''
                  if (row.Description) {
                    res = row.Description.replace(/\\par[d]?/g, '')
                  }
                  return res.replace(/\{\*?\\[^{}]+}|[{}]|\\\n?[A-Za-z]+\n?(?:-?\d+)?[ ]?/g, '').trim()
                }
              },
              {
                label: 'Notes',
                value: row => {
                  let res = ''
                  if (row.Notes) {
                    res = row.Notes.replace(/\\par[d]?/g, '')
                  }
                  return res.replace(/\{\*?\\[^{}]+}|[{}]|\\\n?[A-Za-z]+\n?(?:-?\d+)?[ ]?/g, '').trim()
                }
              },
              {
                label: 'Seller Name',
                value: 'Seller_Name'
              },
              {
                label: 'Seller Contacts',
                value: 'Seller_Contacts'
              },
              {
                label: 'Warranty End Date',
                value: row => row.Warranty_End_Date ? formatLocalDate(row.Warranty_End_Date) : ''
              }
            ],
            content: res.data
          }
        ]
        xlsx(data, { fileName: 'Assets' })
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    }
  },
  filters: {
    dateFilter (val) {
      return val ? formatLocalDate(val) : ''
    }
  }
}
</script>
<style lang="scss" scoped>
  .checkbox-center > .v-input__control > .v-input__slot {
    justify-content: center;
  }
  .border-black {
    border: 1px solid black;
    left: 40%;
    right: 40%;
  }
</style>
